/* eslint-disable @typescript-eslint/no-unused-vars */
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';
import { GetVehicleMROsPaginatedResponse, VehicleMROResponse } from '../../app/features/vehicles/domain/mro-manual-model';
import { MroGPSRepository } from '../../app/features/vehicles/infrastructure/mro-gps.repository';
import { VehicleMROResponseMock } from '../dataMocks/vehicle-mro-response-mock';

export class MroGPSApiServiceMock implements MroGPSRepository {
    createVehicleGPS(vehicleId: string, addressId: string): Observable<VehicleMROResponse> {
        return of({ ...VehicleMROResponseMock });
    }

    deleteVehicleGPS(vehicleId: string, miles: number, odometerPhoto: File, feedback: string): Observable<VehicleMROResponse> {
        return of({ ...VehicleMROResponseMock });
    }

    getVehicleGPSById(vehicleId: string): Observable<VehicleMROResponse> {
        return of({ ...VehicleMROResponseMock });
    }

    getVehicleGPSByUserId(page = 1, size = 10): Observable<GetVehicleMROsPaginatedResponse> {
        return of({
            content: [{ ...VehicleMROResponseMock }],
            pagination: {
                currentPage: page,
                pageSize: size,
                totalElements: 1,
                totalPages: 1,
            },
        });
    }
}
